import React, { useEffect, useState } from "react";

import { isPositiveInteger } from "helpers/Helpers";
import { isEqual } from "lodash";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";

import { StatusCode } from "api/protocols";

import Card from "components/card/Card";
import Page from "components/page/Page";
import Input from "components/form/input/Input";
import FormLayout from "components/form/FormLayout";
import { ButtonNew as Button } from "components/buttonNew/";
import { NotificationType } from "components/notificationBar/NotificationBar";

import { IUIActions } from "redux/actions/ui";

import "./floorPlanNew.scss";
import { PostFloorPlan } from "api/rpc/2024-04/facilityAdmin/tables/tables";

interface IFloorPlanEditProps {
  uiActions: IUIActions;
}

interface IFloorPlanNewState {
  title: string;
  gridWidth: number;
  gridHeight: number;
}

export default function FloorPlanNew(props: IFloorPlanEditProps) {
  const { uiActions } = props;

  const { t, i18n } = useTranslation();

  const [floorPlanNewState, setFloorPlanNewState] = useState<IFloorPlanNewState>({
    title: "",
    gridWidth: 30,
    gridHeight: 30,
  });

  function isEmpty(value: string) {
    return value === "" || value === undefined || value === null;
  }

  async function handleSaveFloorPlan() {
    if (isEmpty(floorPlanNewState.title)) {
      uiActions.showError(t("Title is required for a floor plan"));
      return;
    }

    const newFloorPlanRes = await PostFloorPlan(
      {
        title: floorPlanNewState.title,
        grid_width: floorPlanNewState.gridWidth,
        grid_height: floorPlanNewState.gridHeight,
      },
      true,
    );

    if (newFloorPlanRes.status !== StatusCode.OK) {
      uiActions.showError(t("Error creating floor plan"));
      return;
    }

    history.back();
  }

  const primaryAction = {
    content: t("Save"),
    action: handleSaveFloorPlan,
  };

  return (
    <Page
      title={t("Floor Plan")}
      narrow
      breadcrumbs={[
        {
          prefix: true,
          label: t("Floor Plans"),
          url: "/admin/settings/floor-plan",
        },
      ]}
      primaryAction={primaryAction}
    >
      <div>
        <Card>
          <Card.Section>
            <FormLayout>
              <FormLayout.Group>
                <Input
                  label={t("Title")}
                  value={floorPlanNewState.title}
                  onChange={(e: any) => setFloorPlanNewState(prev => ({ ...prev, title: e.target.value }))}
                />
              </FormLayout.Group>
            </FormLayout>
          </Card.Section>
        </Card>
      </div>
    </Page>
  );
}
